// @ts-nocheck
import {
    error,
    robotoRegular,
    scarpaGray000,
    scarpaGray100,
    scarpaGray25,
    scarpaGray300,
    scarpaGray400,
    scarpaGray500,
    scarpaGray600,
    scarpaGray800,
} from '@habitech/shared';
import styled from 'styled-components';

/** Espacio vertical entre tarjetas del formulario */
export const FormStack = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

/** Tarjeta / panel de agrupación */
export const FormPanel = styled.section`
    display: flex;
    flex-direction: column;
    gap: 18px;
    padding: 22px 20px 24px;
    background: ${scarpaGray000};
    border: 1px solid ${scarpaGray100};
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(29, 26, 32, 0.06);
    font-size: 16px;

    @media ${({ theme }) => theme.screenSizes.tablet} {
        padding: 26px 28px 28px;
    }
`;

export const RequiredBar = styled.p`
    font-family: ${robotoRegular};
    font-size: 16px;
    line-height: 1.45;
    color: ${scarpaGray500};
    margin: 0;
    padding: 10px 14px;
    border-radius: 8px;
    background: ${scarpaGray25};
    border: 1px solid ${scarpaGray100};
`;

export const SectionHeading = styled.h2`
    font-family: ${robotoRegular};
    font-size: 15px;
    font-weight: 600;
    line-height: 1.3;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: ${scarpaGray600};
    margin: 0 0 2px;
`;

export const SectionDescription = styled.p`
    font-family: ${robotoRegular};
    font-size: 16px;
    line-height: 1.5;
    color: ${scarpaGray500};
    margin: 0 0 12px;
`;

export const FormDivider = styled.hr`
    border: none;
    border-top: 1px solid ${scarpaGray100};
    margin: 2px 0;
    width: 100%;
`;

/** Grupo campo: etiqueta + ayuda + control + error */
export const FieldBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const FieldLabel = styled.span`
    font-family: ${robotoRegular};
    font-size: 16px;
    font-weight: 600;
    line-height: 1.35;
    color: ${scarpaGray800};
    letter-spacing: 0.01em;
`;

export const HelperText = styled.span`
    font-family: ${robotoRegular};
    font-size: 16px;
    line-height: 1.45;
    color: ${scarpaGray500};
    margin-top: -2px;
`;

export const LockedField = styled.div`
    pointer-events: none;
    opacity: 0.94;
    padding: 12px 14px;
    border-radius: 10px;
    border: 1px dashed ${scarpaGray300};
    background: ${scarpaGray25};
`;

/** Vigencia: en tablet, inicio y fin en una fila; duración a ancho completo debajo */
export const VigenciaGrid = styled.div`
    display: grid;
    gap: 18px;
    width: 100%;
    grid-template-columns: 1fr;

    @media ${({ theme }) => theme.screenSizes.tablet} {
        grid-template-columns: 1fr 1fr;
        grid-auto-rows: auto;

        & > *:nth-child(1) {
            grid-column: 1;
            grid-row: 1;
        }
        & > *:nth-child(2) {
            grid-column: 2;
            grid-row: 1;
        }
        & > *:nth-child(3) {
            grid-column: 1 / -1;
            grid-row: 2;
        }
    }
`;

export const DurationBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding-top: 2px;

    @media ${({ theme }) => theme.screenSizes.tablet} {
        padding: 14px 16px 4px;
        margin: 0 -4px;
        border-radius: 10px;
        background: ${scarpaGray25};
        border: 1px solid ${scarpaGray100};
    }
`;

export const DatePickerField = styled.div`
    flex: 1;
    min-width: 0;

    .MuiFormControl-root {
        width: 100%;
    }

    .MuiInputBase-input {
        font-size: 16px;
    }

    .MuiInputLabel-root {
        font-size: 16px;
    }

    .MuiFormHelperText-root {
        font-size: 16px;
    }
`;

export const RadioGroup = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px 24px;
    padding: 2px 0 6px;
`;

export const FieldError = styled.p`
    font-family: ${robotoRegular};
    font-size: 16px;
    line-height: 1.35;
    color: ${error};
    margin: 2px 0 0;
`;

/** Panel anidado (p. ej. leads en Free) */
export const InsetPanel = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 14px 16px 16px;
    margin-top: 4px;
    border-radius: 10px;
    background: ${scarpaGray000};
    border: 1px solid ${scarpaGray100};
    border-left: 3px solid ${scarpaGray400};
`;

export const FormActions = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 16px;
    margin-top: 4px;
    padding-top: 24px;

    button {
        min-width: 168px;
    }
`;

/** Compat: usado si algún fragmento aún importa nombres antiguos */
export const FormSection = FieldBlock;
export const VigenciaColumn = VigenciaGrid;
export const DateFieldsRow = VigenciaGrid;
